import {formsStore as legacyStore} from '../_legacy/Form/stores/FormsStore';

export const isLegacyStore = () => {
    return !!legacyStore.currentSession;
};
